import { Link } from "react-router-dom";
import { Brand } from "./Brand";

export default function MarketingFooter() {
  return (
    <footer className="border-t border-[#EAEAE3] py-12 bg-[#FAFAF7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <Brand />
        <nav className="flex items-center gap-7 text-sm text-[#5C5C66]">
          <Link to="/pricing" className="hover:text-[#0A0A0F] transition-colors">Pricing</Link>
          <Link to="/terms" className="hover:text-[#0A0A0F] transition-colors">Terms</Link>
          <Link to="/privacy" className="hover:text-[#0A0A0F] transition-colors">Privacy</Link>
          <Link to="/login" className="hover:text-[#0A0A0F] transition-colors">Sign in</Link>
          <Link to="/signup" className="hover:text-[#0A0A0F] transition-colors">Get started</Link>
        </nav>
        <div className="text-xs font-mono uppercase tracking-widest text-[#9A9AA3]">© 2026 LeadsB2B</div>
      </div>
    </footer>
  );
}
